import { render } from "./KapibaraTeaching.vue?vue&type=template&id=0e93f0c4"
import script from "./KapibaraTeaching.vue?vue&type=script&lang=js"
export * from "./KapibaraTeaching.vue?vue&type=script&lang=js"

import "./KapibaraTeaching.vue?vue&type=style&index=0&id=0e93f0c4&lang=scss"

import exportComponent from "D:\\experement\\kapibara\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__